<app-order-details-data-card [order]="order()" />

@if (isCancelled()) {
  <div class="mt-4">
    @if (allInstallments().length === 0) {
      <p class="text-center mt-5">Nenhuma parcela até o momento.</p>
    }
    @for (installment of pagedAllInstallments(); track installment.id) {
      <div class="card mb-2! flex justify-between items-center">
        <div class="w-full flex flex-wrap gap-2 lg:gap-0 items-center">
          <div
            [innerHTML]="getInstallmentStatusComponent(installment.status)"
            class="w-fit mr-3"
          ></div>
          <div
            class="w-full lg:w-[70%] flex flex-wrap lg:flex-nowrap gap-2 lg:gap-6"
          >
            <div class="w-full lg:w-fit">
              <p>Parcela</p>
              <p class="font-bold">
                {{ installment.number }} de
                {{ order()?.paymentPlan?.installmentCount }}
              </p>
            </div>

            <div class="w-full lg:w-fit">
              <p>Valor</p>
              <p class="font-bold">
                {{ installment.totalAmount | currency }}
              </p>
            </div>
            @if (!isPaidInstallment(installment)) {
              <div class="w-full lg:w-fit">
                <p>Vence em</p>
                <p class="font-bold">
                  {{ installment.dueDate | date: "dd / MMM / yyyy" }}
                </p>
              </div>

              @if (installment.taxAmount && installment.taxAmount > 0) {
                <div class="w-full lg:w-fit">
                  <p>Valor da Taxa</p>
                  <p class="font-bold">
                    {{ installment.taxAmount | currency }}
                  </p>
                </div>
              }
              @if (installment.taxRate && installment.taxRate > 0) {
                <div class="w-full lg:w-fit">
                  <p>Percentual da Taxa</p>
                  <p class="font-bold">
                    {{ installment.taxRate | number: "1.2-2" }}%
                  </p>
                </div>
              }
              @if (installment.invoice) {
                <div class="w-full lg:w-fit">
                  <p>Invoice</p>
                  <a
                    [href]="installment.invoice.invoiceUrl"
                    target="_blank"
                    class="text-blue-600 hover:underline"
                  >
                    <i class="ph ph-scroll"></i>
                    Visualizar
                  </a>
                </div>
                <div class="w-full lg:w-fit">
                  <p>Status Invoice</p>
                  <p class="font-bold">
                    {{
                      getInvoiceStatusDescription(installment.invoice.status)
                    }}
                  </p>
                </div>
              }
            }
          </div>
        </div>
        @if (installment.payments.length > 0) {
          <div class="w-fit mr-10">
            <p-button
              type="button"
              icon="ph ph-eye"
              [rounded]="true"
              [outlined]="true"
              (click)="openInstallmentPaymentsDialog(installment)"
              pTooltip="Detalhes do pagamento"
              tooltipStyleClass="whitespace-nowrap"
              tooltipPosition="top"
            />
          </div>
        }
      </div>
    }
    @if (allInstallments().length) {
      <div class="mt-4">
        <p-paginator
          [first]="allFirst()"
          [rows]="allRows()"
          [totalRecords]="allInstallments().length"
          [rowsPerPageOptions]="[5, 10, 20, 50]"
          (onPageChange)="onAllPageChange($event)"
        />
      </div>
    }
  </div>
} @else {
  <app-tabs [defaultActive]="1" class="mt-4">
    <app-tab-options class="bg-white">
      <app-tab-option value="1">Próximas</app-tab-option>
      <app-tab-option value="2">Pagas</app-tab-option>
    </app-tab-options>
    <app-tab-panels>
      <app-tab-panel>
        @if (installments().length === 0) {
          <p class="text-center mt-5">Nenhuma parcela até o momento.</p>
        }
        @for (installment of pagedInstallments(); track installment.id) {
          <div class="card mb-2! flex justify-between items-center">
            <div class="w-full flex flex-wrap gap-2 lg:gap-0 items-center">
              <div
                [innerHTML]="getInstallmentStatusComponent(installment.status)"
                class="w-fit mr-3"
              ></div>
              <div
                class="w-full lg:w-[70%] flex flex-wrap lg:flex-nowrap gap-2 lg:gap-6"
              >
                <div class="w-full lg:w-fit">
                  <p>Parcela</p>
                  <p class="font-bold">
                    {{ installment.number }} de
                    {{ order()?.paymentPlan?.installmentCount }}
                  </p>
                </div>
                <div class="w-full lg:w-fit">
                  <p>Valor</p>
                  <p class="font-bold">
                    {{ installment.totalAmount | currency }}
                  </p>
                </div>
                <div class="w-full lg:w-fit">
                  <p>Vence em</p>
                  <p class="font-bold">
                    {{ installment.dueDate | date: "dd / MMM / yyyy" }}
                  </p>
                </div>
              </div>
            </div>
            @if (
              installment.payments.length > 0 ||
              isChargeableInstallment(installment)
            ) {
              <div class="w-fit flex gap-2 mr-10">
                @if (isChargeableInstallment(installment)) {
                  <p-button
                    type="button"
                    icon="ph ph-credit-card"
                    [rounded]="true"
                    [outlined]="true"
                    [loading]="chargingInstallmentId() === installment.id"
                    [disabled]="chargingInstallmentId() !== null"
                    (click)="requestChargeInstallment(installment, $event)"
                    title="Cobrar cliente"
                    pTooltip="Fazer cobrança"
                    tooltipPosition="top"
                  />
                }
                @if (installment.payments.length > 0) {
                  <p-button
                    type="button"
                    icon="ph ph-eye"
                    [rounded]="true"
                    [outlined]="true"
                    (click)="openInstallmentPaymentsDialog(installment)"
                    pTooltip="Detalhes do pagamento"
                    tooltipStyleClass="whitespace-nowrap"
                    tooltipPosition="top"
                  />
                }
              </div>
            }
          </div>
        }
        @if (installments()!.length) {
          <div class="mt-4">
            <p-paginator
              [first]="first()"
              [rows]="rows()"
              [totalRecords]="installments().length"
              [rowsPerPageOptions]="[5, 10, 20, 50]"
              (onPageChange)="onPageChange($event)"
            />
          </div>
        }
      </app-tab-panel>
      <app-tab-panel>
        @if (paidInstallments().length === 0) {
          <p class="text-center mt-5">Nenhuma parcela paga até o momento.</p>
        }
        @for (installment of pagedPaidInstallments(); track installment.id) {
          <div class="card mb-2! flex justify-between items-center">
            <div class="w-full flex flex-wrap gap-2 lg:gap-0 items-center">
              <div
                [innerHTML]="getInstallmentStatusComponent(installment.status)"
                class="w-fit mr-3"
              ></div>
              <div
                class="w-full lg:w-[70%] flex flex-wrap lg:flex-nowrap gap-2 lg:gap-6"
              >
                <div class="w-full lg:w-fit">
                  <p>Parcela</p>
                  <p class="font-bold">
                    {{ installment.number }} de
                    {{ order()?.paymentPlan?.installmentCount }}
                  </p>
                </div>
                <div class="w-full lg:w-fit">
                  <p>Valor</p>
                  <p class="font-bold">
                    {{ installment.totalAmount | currency }}
                  </p>
                </div>
              </div>
            </div>
            @if (installment.payments.length > 0) {
              <div class="w-fit mr-10">
                <p-button
                  type="button"
                  icon="ph ph-eye"
                  [rounded]="true"
                  [outlined]="true"
                  (click)="openInstallmentPaymentsDialog(installment)"
                  pTooltip="Detalhes do pagamento"
                  tooltipStyleClass="whitespace-nowrap"
                  tooltipPosition="top"
                />
              </div>
            }
          </div>
        }
        @if (paidInstallments()!.length) {
          <div class="mt-4">
            <p-paginator
              [first]="paidFirst()"
              [rows]="paidRows()"
              [totalRecords]="paidInstallments().length"
              [rowsPerPageOptions]="[5, 10, 20, 50]"
              (onPageChange)="onPaidPageChange($event)"
            />
          </div>
        }
      </app-tab-panel>
    </app-tab-panels>
  </app-tabs>
}

<app-order-installment-payments-dialog
  [(visible)]="installmentPaymentDialogVisible"
  [installment]="paymentInstallment"
  [order]="order()"
/>
